<template>
  <div>
    <v-container fluid>
      <v-card class="card2">
        <v-row style="border-bottom: 1px solid #c9c9c9">
          <v-col cols="12" md="6">
            <h1 style="font-weight: 600" class="ml-4">{{ $t('_DocumentManagement') }}</h1>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <!-- Stepper -->
        <v-stepper class="mt-4 custom-stepper uv-no-shadow" alt-labels show-actions v-if="!isEditMode">
          <v-stepper-header class="customstep-header uv-no-shadow">
            <v-stepper-item :complete="step > 1" step="1" value="1" :title="$t('basicInformation')" />
            <v-img :src="images.dividerImg" v-if="step == 1"></v-img>
            <v-img :src="images.dividercompleteImg" v-if="step == 2"></v-img>
            <v-stepper-item :complete="step > 2" step="2" value="2" :title="$t('documentSetting')" />
          </v-stepper-header>

          <v-stepper-window v-model="step">
            <!-- STEP 1 -->
            <v-stepper-window-item value="1">
              <v-form class="mt-4" ref="formStep1">
                <v-row>
                  <v-col cols="12" md="8">
                    <label class="input-label" for="documentname-field-uploadvector-upload">{{ $t('documentName') }}</label><span class="required">* </span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoVectorDatabaseName') }}</span>
                    </v-tooltip>
                    <v-text-field
                      id="documentname-field-uploadvector-upload"
                      @keypress="handleKeypress"
                      @paste="handlePaste"
                      :error="!!errors.documentNameError"
                      :error-messages="errors.documentNameError"
                      :rules="[rules.required]"
                      :disabled="actionEdit"
                      v-model="searchVectorDBName2"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('documentName')"
                      class="modern-input"
                      maxlength="500"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <h3 class="uv-fw-bold">{{ $t('_DocumentTypeProcessing') }}</h3>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="input-label" for="doctype-select-uploadvector-upload">{{ $t('documentType') }}</label> <span class="required">* </span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoDoctype') }}</span>
                    </v-tooltip>
                    <v-select
                      id="doctype-select-uploadvector-upload"
                      :error="!!errors.doctypeError"
                      :placeholder="$t('documentType')"
                      :error-messages="errors.doctypeError"
                      :rules="[rules.required]"
                      :items="datadoctype"
                      item-title="name"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="doctype"
                      return-object
                      @update:model-value="setTypeFile(doctype.value)"
                      class="modern-input replace-mdi-bfe"
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props" :id="'doctype-option-' + item.raw.id" :value="item.raw.value">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <label class="input-label" for="vectortype-select-uploadvector-upload">{{ $t('vectortype') }}</label> <span class="required">* </span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoVectortype') }}</span>
                    </v-tooltip>
                    <v-select
                      id="vectortype-select-uploadvector-upload"
                      :error="!!errors.vectortypeError"
                      :error-messages="errors.vectortypeError"
                      :rules="[rules.required]"
                      :placeholder="$t('vectortype')"
                      :items="filterdatavectortype"
                      item-title="name"
                      item-value="value"
                      variant="outlined"
                      class="modern-input replace-mdi-bfe"
                      density="compact"
                      hide-details="auto"
                      v-model="vectortype"
                      return-object
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props" :id="'vectortype-option-' + item.raw.id" :value="item.raw.value">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <label class="input-label" for="type-autocomplete-uploadvector-upload">{{ $t('processingMethod') }}</label> <span class="required">* </span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfofillterModelType') }}</span>
                    </v-tooltip>
                    <v-autocomplete
                      id="type-autocomplete-uploadvector-upload"
                      :error="!!errors.modelTypeError"
                      :error-messages="errors.modelTypeError"
                      :items="filterDDType"
                      item-title="name"
                      :placeholder="$t('processingMethod')"
                      item-value="value"
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input replace-mdi-bfe"
                      :rules="[rules.required]"
                      v-model="requestVector.modelType"
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item :id="'processing-method-option-' + item.raw.id" :value="item.raw.value" v-bind="props" :title="item.raw.name" class="processing-item">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                          <template v-slot:append>
                            <v-tooltip location="right" max-width="400px">
                              <template v-slot:activator="{ props }">
                                <v-icon v-bind="props" size="small" class="help-icon">mdi-information-outline</v-icon>
                              </template>
                              <div class="tooltip-image">
                                <img :src="item.raw.image" alt="Tooltip preview" width="300" />
                              </div>
                            </v-tooltip>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" v-show="requestVector.modelType == 3">
                    <label class="input-label" for="customcharacter-field-uploadvector-upload">{{ $t('customCharacter') }}</label><span class="required">* </span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoCustomCharacter') }}</span>
                    </v-tooltip>
                    <v-text-field
                      id="customcharacter-field-uploadvector-upload"
                      v-model="requestVector.customCharacter"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('enterCharacter')"
                      class="modern-input"
                      :rules="[checkCustomCharacterValidate()]"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mt-4">
                  <v-col cols="12" md="4">
                    <h3 class="uv-fw-bold">{{ $t('templateDocument') }}</h3>
                    <span style="color: #646464; font-size: 13px"> {{ $t('_InfoTemplateDocument') }} </span>
                    <br />
                    <v-btn color="error" class="mt-3 uv-btn-rounded-flat" variant="outlined" @click="TemplateVectorDialog()" prepend-icon="mdi-download"> {{ $t('template') }} </v-btn>
                  </v-col>

                  <v-col cols="12" md="8">
                    <h3 class="uv-fw-bold">{{ $t('uploadFile') }}</h3>
                    <div class="form-group upload-section" @click="triggerFileUpload">
                      <div class="upload-container">
                        <div class="upload-area" :class="{ 'upload-area--ready': isUploadReady }">
                          <!-- DragDropFile ที่ซ่อนไว้ -->
                          <DragDropFile
                            ref="dragDropRef"
                            :dialog="true"
                            :DragDrop="false"
                            :ShowListFile="false"
                            :accept="accept"
                            :multiple="true"
                            @filesUploaded="processUpload($event)"
                            :allowType="[]"
                            class="modern-upload hidden-upload"
                          />
                          <div class="upload-content">
                            <v-img :src="images.uploadImg" width="30" height="30" class="mb-4 upload-state-icon" />
                            <p class="drag-text">
                              {{ $t('_DragAndDropOr') }}
                              <span class="choose-file-link">{{ $t('chooseFileToUpload') }}</span>
                            </p>
                            <div class="upload-info">
                              <div class="upload-description">
                                <span>{{ $t('maximumTotalUploadSize') }}: {{ maxUploadMB }} MB</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="uploadedFiles.length == 1" class="myrandonthing">
                      <v-row>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="1" class="pt-1">
                              <v-img :src="getFileIcon(uploadedFiles[0].name)" width="38" height="38" class="mr-2 mt-1" />
                            </v-col>
                            <v-col class="pt-1 filename-txt">
                              <span class="filename-txt">
                                {{ uploadedFiles[0].name }} </span
                              ><br />
                              <span class="filesize-txt">{{ formatFileSize(uploadedFiles[0].size) }}</span></v-col
                            >
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1" class="pt-1 pr-0 d-flex justify-end">
                          <v-img :src="images.delete1" @click="deleteSingleFile(1)" width="34" height="34" class="ml-2 mt-1" style="cursor: pointer" /></v-col
                      ></v-row>
                    </div>

                    <!-- Multiple files table -->
                    <div v-if="uploadedFiles.length > 1" class="files-table-container mt-4">
                      <v-card variant="outlined" class="files-table-card">
                        <v-data-table
                          v-model="selectedFiles"
                          :headers="fileTableHeaders"
                          :items="uploadedFiles"
                          item-key="name"
                          class="files-data-table"
                          density="compact"
                          hide-default-footer
                          hide-default-header
                          disable-pagination
                          :items-per-page="-1"
                        >
                          <template v-slot:top>
                            <div flat class="files-table-header">
                              <v-checkbox v-model="selectAll" :indeterminate="isIndeterminate" @change="toggleSelectAll" hide-details class="custom-checkbox" :label="$t('selectAll')"></v-checkbox>
                              <v-spacer></v-spacer>
                              <v-btn v-if="selectedFiles.length > 0" color="error" variant="outlined" class="uv-btn-rounded-flat" @click="deleteSelectedFiles">
                                <v-img :src="images.delete1" class="mr-1" width="22" height="22" />
                                <span class="pt-1">
                                  {{ selectedFiles.length === uploadedFiles.length ? $t('deleteAll') : `${$t('deleteSelected')} (${selectedFiles.length})` }}
                                </span>
                              </v-btn>
                            </div>
                          </template>
                          <template v-slot:item.name="{ item }">
                            <div class="file-name-cell">
                              <v-checkbox v-model="item.checked" hide-details @change="onItemCheckChange(item, $event)" class="custom-checkbox"></v-checkbox>
                              <v-row>
                                <v-col cols="1" class="pt-2">
                                  <v-img :src="getFileIcon(item.name)" width="38" height="38" class="mr-2 mt-1" />
                                </v-col>
                                <v-col cols="6" class="pt-2 filename-txt">
                                  <span class="filename-txt">
                                    {{ item.name }} </span
                                  ><br />
                                  <span class="filesize-txt">{{ formatFileSize(item.size) }}</span></v-col
                                >
                              </v-row>
                            </div>
                          </template>

                          <template v-slot:item.actions="{ item }">
                            <v-img :src="images.delete1" @click="deleteSingleFile(item)" width="30" height="30" class="ml-2" style="cursor: pointer" />
                          </template>
                        </v-data-table>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-form>

              <v-card-actions class="justify-end mt-6">
                <v-btn variant="flat" class="savebtn" @click="nextStep">
                  {{ $t('next') }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-stepper-window-item>

            <!-- STEP 2 -->
            <v-stepper-window-item value="2">
              <v-form class="mt-4" ref="formStep2">
                <v-col cols="12" class="pl-0">
                  <h3 class="uv-fw-bold">Document Type & Processing</h3>
                </v-col>
                <v-row>
                  <v-col cols="12" md="4">
                    <label class="input-label" for="custommaxcharacter-field-uploadvector-upload">{{ $t('maxCharacterChunk') }}</label>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoCustomMaxCharacter') }}</span>
                    </v-tooltip>
                    <v-text-field
                      id="custommaxcharacter-field-uploadvector-upload"
                      :rules="[rules.required]"
                      @keypress="numericKey"
                      v-model="requestVector.MaxLimitedCharacter"
                      variant="outlined"
                      class="modern-input"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('maxCharacterChunk')"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <div class="lang-detect-wrapper" :style="requestVector.PersonalInfo ? 'background: #FFF2F2' : 'background: #EDEDED'">
                      <label class="uv-fw-bold" for="switch-detect-personal-information-upload"
                        >{{ $t('personalInformation') }}
                        <v-tooltip location="right" max-width="280px">
                          <template #activator="{ props }">
                            <v-icon size="small" v-bind="props" class="help-icon"> mdi-information-outline </v-icon>
                          </template>
                          <span>
                            {{ $t('_InfoPersonalInfoEnabled') }}
                            <br />
                            {{ $t('_InfoPersonalInfoDisabled') }}
                          </span>
                        </v-tooltip>
                      </label>
                      <div class="lang-detect-body">
                        <span>{{ $t('_ControlAccessPersonalInfo') }}</span>
                        <v-switch
                          id="switch-detect-personal-information-upload"
                          v-model="requestVector.PersonalInfo"
                          color="#C32E0E"
                          inset
                          hide-details
                          :class="['publication-toggle', requestVector.PersonalInfo ? 'publication-toggle--active' : 'publication-toggle--inactive']"
                          @change="UpdatePersonalInformation(searchVectorDBName2, $event)"
                        >
                        </v-switch>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" md="4" class="d-flex align-center">
                    <div class="lang-detect-wrapper" :class="{ 'lang-detect-on': requestVector.DetectLanguage }" :style="requestVector.DetectLanguage ? 'background: #FFF2F2' : 'background: #EDEDED'">
                      <div class="lang-detect-header">
                        <label class="lang-detect-label uv-fw-bold" for="switch-detect-language-uploadvector-upload">{{ $t('languageDetection') }}</label>
                        <v-tooltip location="right" max-width="280px">
                          <template #activator="{ props }">
                            <v-icon size="small" v-bind="props" class="help-icon"> mdi-information-outline </v-icon>
                          </template>
                          <span>
                            {{ $t('_InfoLangDetectEnabled') }}
                            <br />
                            {{ $t('_InfoLangDetectDisabled') }}
                          </span>
                        </v-tooltip>
                      </div>

                      <div class="lang-detect-body">
                        <span>{{ $t('_AutoDetectInputLang') }}</span>
                        <v-switch
                          id="switch-detect-language-uploadvector-upload"
                          v-model="requestVector.DetectLanguage"
                          inset
                          color="red-lighten-1"
                          hide-details
                          class="mr-5"
                          :class="['publication-toggle', requestVector.DetectLanguage ? 'publication-toggle--active' : 'publication-toggle--inactive']"
                        >
                        </v-switch>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="input-label" for="textreplacement-autocomplete-uploadvector-upload">{{ $t('textReplacement') }}</label>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoGroupReplaceText') }}</span>
                    </v-tooltip>
                    <v-autocomplete
                      id="textreplacement-autocomplete-uploadvector-upload"
                      :items="DDGroupReplace"
                      item-title="name"
                      item-value="id"
                      multiple
                      chips
                      closable-chips
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('textReplacement')"
                      class="modern-input replace-mdi-bfe"
                      v-model="tempgroupReplaceID"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'textreplacement-uploadvector-upload-option-' + index" :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions class="justify-space-between mt-6">
                <v-btn outlined class="backbtn" @click="prevStep">
                  <v-icon left>mdi-arrow-left</v-icon>
                  {{ $t('back') }}
                </v-btn>

                <v-btn class="savebtn" @click="saveDoc()">
                  <v-img :src="images.savebtn" class="mr-2" width="16" height="16"></v-img>
                  {{ $t('save') }}
                </v-btn>
              </v-card-actions>
            </v-stepper-window-item>
          </v-stepper-window>
        </v-stepper>

        <v-flex>
          <!-- Search and Management Section -->
          <div class="search-wrapper mt-5" v-if="isEditMode == true">
            <div class="search-card" elevation="0" variant="outlined">
              <div class="search-content">
                <v-row class="search-row" align="center">
                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <v-text-field
                        id="add-field-search-uploadvector"
                        v-model="searchtext_org"
                        variant="outlined"
                        density="compact"
                        hide-details
                        clearable
                        class="modern-input"
                        :placeholder="$t('searchDocumentContent')"
                        @keyup.enter="Search"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="error">mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-switch
                      v-model="CheckboxShowAllText"
                      hide-details
                      density="compact"
                      inset
                      id="add-checkbox-search-uploadvector"
                      :class="['publication-toggle', CheckboxShowAllText ? 'publication-toggle--active' : 'publication-toggle--inactive']"
                    >
                      <template #label>
                        <div class="toggle-label">
                          <span style="font-size: 1rem">{{ $t('_ShowFullText') }}</span>
                        </div>
                      </template>
                    </v-switch>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-switch
                      v-model="requestVector.PersonalInfo"
                      hide-details
                      density="compact"
                      inset
                      id="switch-detect-personal-information-table"
                      :class="['publication-toggle', requestVector.PersonalInfo ? 'publication-toggle--active' : 'publication-toggle--inactive']"
                      @change="UpdatePersonalInformation(searchVectorDBName2, $event)"
                    >
                      <template #label>
                        <div class="toggle-label">
                          <span style="font-size: 1rem">{{ $t('personalInformation') }}</span>
                        </div>
                      </template>
                    </v-switch>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="action-controls-uploadvector" style="background-color: transparent; border: none">
                      <v-btn id="button-reprocess-uploadvector" width="30" variant="flat" class="action-btn" @click="ReProcess()" style="background: rgba(255, 167, 38, 0.1)">
                        <v-img :src="images.reprocess" width="20" height="20"></v-img>
                        <span v-if="needsReprocessing" class="notification-badge">!</span>
                      </v-btn>

                      <v-btn variant="outlined" prepend-icon="mdi-information-outline" class="info-btn" color="#C32E0E" @click="ReFresh()"> {{ dataUpdate }} / {{ dataAll }} </v-btn>

                      <v-menu location="bottom">
                        <template v-slot:activator="{ props }">
                          <v-btn id="button-adddocumentperchunk-menu-uploadvector" v-bind="props" variant="flat" prepend-icon="mdi-plus" class="savebtn">
                            {{ $t('add') }}
                          </v-btn>
                        </template>
                        <v-card min-width="150" elevation="8" rounded="lg">
                          <v-list>
                            <v-list-item id="menu-adddocumentperchunk-uploadvector" class="template-item" @click="AddVectorperChunk()">
                              <v-list-item-title>{{ $t('addChunk') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item id="menu-replacealldocument-uploadvector" class="template-item" @click="gotoEditPage(1)">
                              <v-list-item-title>{{ $t('uploadFile') }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>

                      <v-btn id="button-adddocumentperchunk-direct-uploadvector" variant="flat" class="savebtn" @click="gotoEditPage(2)">
                        <v-img :src="images.replaceall" width="20" height="20" class="mr-2"></v-img>
                        {{ $t('replaceAll') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
            <v-data-table-server
              id="datatable-uploadvertor"
              v-if="showTable == true"
              v-model:options="options2"
              :items-per-page="itemsPerPage2"
              :total-items="searchTotalTable2"
              :items="dataTable2"
              :headers="headers2"
              :loading="loadingTable"
              :loading-text="$t('_Loading')"
              mobile-breakpoint="300"
              :items-length="searchTotalTable2"
              class="elevation-1 responsive-table mt-2"
              :row-props="getRowProps"
            >
              <!-- ใช้ v-slot:item.[column] แทน v-slot:item เพื่อ custom column -->
              <template v-slot:item.number="{ item }">
                <div class="d-flex align-center justify-center" style="gap: 4px">
                  {{ item.number }}
                  <v-icon v-if="item.wrongData" color="#C32E0E" size="18">mdi-alert-circle</v-icon>
                  <v-tooltip v-if="item.wrongData" activator="parent" location="top"> {{ $t('_DataHasProblem') }} </v-tooltip>
                </div>
              </template>

              <template v-slot:item.textORG="{ item }">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="formatText(item.textORG)"> </span>
                </div>
              </template>

              <template v-slot:item.textEN="{ item }">
                <div class="text-container">
                  <span :class="['pt-2', item.show ? 'text-content-show' : 'text-content']" v-html="formatText(item.textEN)"> </span>
                  <v-btn icon variant="text" size="small" color="error" @click="item.show = !item.show">
                    <v-icon size="18">{{ item.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    <v-tooltip activator="parent" location="top">
                      {{ item.show ? $t('collapseText') : $t('expandText') }}
                    </v-tooltip>
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="action-container-1">
                  <div class="action-group">
                    <v-switch
                      id="switch-vectoronoff-uploadvector"
                      v-model="item.activeFlag"
                      hide-details
                      inset
                      @update:model-value="VectorOnOff(item)"
                      density="compact"
                      :class="['publication-toggle', 'personal-switch', item.activeFlag ? 'publication-toggle--active' : 'publication-toggle--inactive']"
                    >
                    </v-switch>
                    <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="EditVectorperChunk(item)" class="action-btn edit-btn" icon>
                      <img :src="images.edit" alt="Edit" class="uv-icon-25" />
                      <v-tooltip activator="parent" location="top"> {{ $t('edit') }} </v-tooltip>
                    </v-btn>

                    <v-btn id="button-delete-uploadCSV" variant="text" density="comfortable" @click="DeleteById(item.id)" class="action-btn delete-btn" icon :disabled="btnDisableDelete(item)">
                      <img :src="images.delete" alt="Delete" class="uv-icon-25" />
                      <v-tooltip activator="parent" location="top"> {{ $t('delete') }} </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-data-table-server>
          </div>
        </v-flex>
      </v-card>
    </v-container>
    <v-dialog ref="form" v-model="EditVector" persistent max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-text-content">
              <h3 class="dialog-title">{{ $t('editChunk') }}</h3>
              <p class="dialog-subtitle">{{ $t('_UpdateExistingDocContent') }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" size="small" @click="closeUploaddialog" class="close-button" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="add-content">
          <v-form ref="form" lazy-validation>
            <div class="textarea-wrapper">
              <v-textarea
                id="textORG-textarea-popupedit-uploadvector"
                v-model="Edit.textORG"
                variant="outlined"
                auto-grow
                rows="15"
                hide-details
                required
                :placeholder="$t('_TypeOrPasteText')"
                class="content-textarea"
              >
              </v-textarea>
            </div>
          </v-form>
          <v-row class="pt-4 pr-4" justify="end">
            <span class="uv-word-count">
              {{ $t('wordCount') }}: <span class="uv-word-count-num"> {{ getWordCount(Edit.textORG) }} </span>
            </span>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn id="button-closeedit-popupedit-uploadvector" variant="outlined" color="grey-darken-1" @click="closeUploaddialog" class="dialog-action-btn cancel-btn">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn id="button-saveedit-popupedit-uploadvector" variant="elevated" @click="SaveEdit()" class="dialog-action-btn save-btn-add">
            <v-img :src="images.savebtn" alt="Save Icon" width="18" height="18" class="mr-2"></v-img>
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- add dialog -->
    <v-dialog ref="form" v-model="AddVector" max-width="800px" class="modern-dialog">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <h3 class="dialog-title">{{ $t('addNewChunk') }}</h3>
              <p class="dialog-subtitle">{{ $t('_CreateNewChunkContent') }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="closeUploaddialogAdd" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="add-content">
          <v-form ref="form" lazy-validation>
            <div class="textarea-wrapper">
              <v-textarea
                id="textORG-textarea-popupadd-uploadvector"
                v-model="Add.textORG"
                variant="outlined"
                auto-grow
                rows="15"
                hide-details
                required
                :placeholder="$t('_TypeOrPasteText')"
                class="content-textarea"
              >
              </v-textarea>
            </div>
          </v-form>
          <v-row class="pt-4 pr-4" justify="end">
            <span class="uv-word-count">
              {{ $t('wordCount') }}: <span class="uv-word-count-num"> {{ getWordCount(Add.textORG) }} </span>
            </span>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <div class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn variant="outlined" color="grey-darken-1" @click="closeUploaddialogAdd" class="dialog-action-btn cancel-btn"> {{ $t('cancel') }} </v-btn>
              <v-btn id="button-saveadd-popupadd-uploadvector" variant="elevated" @click="SaveAdd()" class="dialog-action-btn save-btn-add">
                <v-img :src="images.savebtn" alt="Save Icon" width="18" height="18" class="mr-2"></v-img>
                {{ $t('save') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-overlay :model-value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card class="loading-card">
          <v-card-text class="text-center pa-6">
            <v-progress-circular indeterminate color="primary" size="64" class="mb-4"> </v-progress-circular>
            <div class="text-h6">{{ $t('loadingpleasewait') }}</div>
            <v-progress-linear indeterminate color="primary" class="mt-4"> </v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <v-dialog v-model="TemplateVector" max-width="800px" persistent>
      <v-card class="template-dialog">
        <v-card-title class="template-header">
          <div class="header-content">
            <div class="header-text">
              <h2 class="dialog-title">{{ $t('templateVector') }}</h2>
              <p class="dialog-subtitle">{{ $t('_InfoTemplateVector') }}</p>
            </div>
          </div>
          <v-btn icon variant="text" size="small" @click="TemplateVector = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="template-content">
          <div class="template-description">
            <v-alert class="mb-4 custom-alert" density="compact">
              <div class="alert-content">
                <strong>{{ $t('howToUseTemplates') }}</strong>
                <ul class="template-instructions">
                  <li>{{ $t('templateStep1') }}</li>
                  <li>{{ $t('templateStep2') }}</li>
                  <li>{{ $t('templateStep3') }}</li>
                  <li>{{ $t('templateStep4') }}</li>
                </ul>
              </div>
            </v-alert>
          </div>

          <!-- PROCESSING TYPE SECTION -->
          <v-card class="pa-5 rounded-lg processcard">
            <h3 class="uv-fw-bold">
              <v-img :src="images.processtype" class="mr-2 uv-inline-mid" width="24" height="24" />
              {{ $t('process_type') }}
            </h3>

            <v-radio-group v-model="selectedType" row>
              <v-row class="mt-5 mb-5">
                <v-col v-for="type in dataTemplate" :key="type.value" cols="12" sm="6" md="4" class="d-flex">
                  <div class="processing-option d-flex" :class="{ active: selectedType === type.value }">
                    <v-radio :label="type.label" :value="type.value" color="red darken-2" hide-details></v-radio>
                    <v-tooltip v-if="type.label == 'Custom Split'" location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" size="small" color="#a6a6a6" class="info-tooltip"> mdi-information-outline </v-icon>
                      </template>
                      <div class="custom-tooltip">
                        <strong>{{ $t('_CustomSplitTemplate') }}</strong><br />
                        {{ $t('_UseSeparatorInstruction') }}<br />
                        {{ $t('example') }}: SplitChunkContent
                      </div>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </v-radio-group>
            <h3 class="uv-fw-bold">
              <v-img :src="images.fileformat" class="mr-2 uv-inline-mid" width="24" height="24" />
              {{ $t('fileFormat') }}
            </h3>

            <v-row class="mt-5">
              <v-col v-for="file in visibleFormats" :key="file.value" cols="12" sm="6" md="2" lg="2">
                <v-card class="text-center hoverable file-card" outlined @click="linkDownload(selectedType, file.value)">
                  <div
                    class="imgsection"
                    :class="{
                      'bg-csv': file.value.includes('CSV'),
                      'bg-excel': file.value.includes('Excel'),
                      'bg-multicol': file.value.includes('ExcelMultiColumn'),
                      'bg-pdf': file.value.includes('PDF'),
                      'bg-word': file.value.includes('Word'),
                      'bg-ppt': file.value.includes('PowerPoint'),
                      'bg-txt': file.value.includes('Text'),
                    }"
                  >
                    <v-img :src="file.icon" width="36" height="36" class="mb-2 mt-1 cardImg" />
                  </div>
                  <div class="text-subtitle-2">{{ file.label }}</div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="template-actions">
          <v-spacer></v-spacer>
          <v-btn variant="elevated" color="red" @click="TemplateVector = false" class="create-btn mr-0">
            <v-icon start>mdi-close</v-icon>
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('delete') }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDelete">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span class="uv-fw-500" v-if="deleteType === 'all'"> {{ $t('_ConfirmDeleteAllFiles') }} </span>
          <span class="uv-fw-500" v-else-if="deleteType === 'individual'"> {{ $t('_ConfirmDeleteTheseFiles') }} </span>
          <span class="uv-fw-500" v-else> {{ $t('_ConfirmDeleteItem') }} </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDelete"> {{ $t('cancel') }} </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDelete">
            <img :src="images.trashBin" alt="Delete" class="white-svg" />
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Reprocess Dialog -->
    <v-dialog v-model="dialog_reprocess" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="reprocess-dialog-title">{{ $t('reprocessDocument') }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelReprocess">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span class="uv-fw-500"> {{ $t('_ConfirmReprocessDocument') }} </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelReprocess"> {{ $t('cancel') }} </v-btn>
          <v-btn class="reprocess-confirm-btn" @click="confirmReprocess">
            <v-icon left size="18">mdi-file</v-icon>
            {{ $t('reprocess') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Doc Delete Dialog -->
    <v-dialog v-model="dialog_delete_doc" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('delete') }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDeleteDoc">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span class="uv-fw-500"> {{ $t('_ConfirmDeleteDocument') }} </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDeleteDoc"> {{ $t('cancel') }} </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDeleteDoc">
            <img :src="images.trashBin" alt="Delete" class="white-svg" />
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Doc Delete Dialog -->
    <v-dialog v-model="dialog_chunk_onoff" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="chunk-dialog-header">
          <span class="chunk-dialog-title">{{ ChunkSwitchHeader === 'Turn Off Chunk' ? $t('turnOffChunk') : $t('turnOnChunk') }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelSwitchChunk">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span class="uv-fw-500" v-if="ChunkSwitchHeader === 'Turn Off Chunk'"> {{ $t('_ConfirmTurnOffChunk') }} </span>
          <span class="uv-fw-500" v-else> {{ $t('_ConfirmTurnOnChunk') }} </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelSwitchChunk"> {{ $t('cancel') }} </v-btn>
          <v-btn class="chunk-confirm-btn" @click="confirmSwitchChunk"> {{ $t('confirm') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DragDropFile from '@/components/DragDropFile.vue';
import generalImg from '@/assets/images/Group 11.svg';
import maxCharacterImg from '@/assets/images/Group 12.svg';
import customSplitImg from '@/assets/images/Group 13.svg';
const articleImg = customSplitImg;
const headerAllChunkImg = generalImg;
const headerFirstChunkImg = maxCharacterImg;
const wordImageImg = maxCharacterImg;
const pdfImageImg = maxCharacterImg;
import csvImg from '@/assets/images/csv.png';
import excelImg from '@/assets/images/excel.png';
import fileexcelImg from '@/assets/images/multi-excel.png';
import pdfImg from '@/assets/images/pdf2.png';
import wordImg from '@/assets/images/microsoft-word.png';
import pptImg from '@/assets/images/powerpoint.png';
import txtImg from '@/assets/images/txt.png';
import dividerImg from '@/assets/images/divider.png';
import dividercompleteImg from '@/assets/images/completeline.png';
import uploadImg from '@/assets/images/upload.png';
import reprocess from '@/assets/images/file-settings-line.png';
import replaceall from '@/assets/images/replaceallwhite.png';
import deleteImg1 from '@/assets/Icons/Delete.png';
import editImg from '@/assets/images/editbutton.png';
import deleteImg from '@/assets/images/trashbutton.png';
import savebtn from '@/assets/images/savecard.png';
import processtype from '@/assets/images/flat-color-icons_process.png';
import fileformat from '@/assets/images/memory_format-text.png';
import TrashBinImg from '@/assets/images/trash-solid.svg';

import { useDisplay } from 'vuetify';
import LogTrace from '@/api/function.js';
import uploadVectorMixin from '@/mixins/uploadVectorMixin.js';

export default {
  name: 'UploadVector',
  mixins: [LogTrace, uploadVectorMixin],
  components: { DragDropFile },
  props: { id: { type: [String, Number] } },
  inject: ['FontColorTitle', 'SubNavbarBackGround', 'Username', 'RoleId'],
  setup() {
    const { smAndUp } = useDisplay();

    return {
      smAndUp,
    };
  },
  data: () => ({
    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    TemplateVector: false,
    dialog: false,
    loadingTable: false,
    EditVector: false,
    vectorName: null,
    step: '1',
    Edit: {
      id: null,
      textORG: null,
    },
    AddVector: false,
    flagNew: true,
    Add: {
      id: null,
      textORG: null,
    },
    loading: true,
    loadingDownload: true,
    today: null,
    searchVectorDBName: null,
    searchVectorDBName2: null,
    searchtext_org: null,
    modelType: null,
    doctype: null,
    vectortype: null,
    tempgroupReplaceID: null,
    options: {},
    options2: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    DDModel: [],
    files: [],
    dataTable: [],
    dataTable2: [],
    uploadedFiles: [],
    selectedFiles: [],
    selectAll: false,
    DDGroupReplace: [],
    filterdatavectortype: [],
    filterDDType: [],
    isSearch: false,
    isSearch2: false,
    isFirst: true,
    isFirst2: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    searchTotalTable2: 0,
    itemsPerPage2: 10,
    showTable: true,
    dataUpdate: -1,
    dataAll: 0,
    exceptionFlag: false,
    clickbyexception: false,
    vectornameDuplicate: false,
    VectorDBNameDuplicate: '',
    DisabledBtn: false,
    accept: '',
    panel: [0],
    images: {
      edit: editImg,
      delete: deleteImg,
      delete1: deleteImg1,
      processtype: processtype,
      fileformat: fileformat,
      csvImg: csvImg,
      excelImg: excelImg,
      fileexcelImg: fileexcelImg,
      pdfImg: pdfImg,
      wordImg: wordImg,
      pptImg: pptImg,
      txtImg: txtImg,
      dividerImg: dividerImg,
      dividercompleteImg: dividercompleteImg,
      uploadImg: uploadImg,
      savebtn: savebtn,
      reprocess: reprocess,
      replaceall: replaceall,
      trashBin: TrashBinImg,
    },
    sortBy: [],
    sortDesc: [],
    ShowAllText: false,
    CheckboxShowAllText: false,
    tempTitle: '',
    tempText: '',
    selectedType: 'General',
    dialog_delete: false,
    dialog_delete_doc: false,
    deleteItem: null,
    deleteType: null,
    dialog_reprocess: false,
    dialog_chunk_onoff: false,
    ChunkSwitchHeader: '',
    autoRefreshRunning: false,
  }),
  created() {
    // Read query param
    this.vectorName = this.$route.query.name;
  },
  computed: {
    isEditMode() {
      return !!(this.$route.query.name || this.vectorName);
    },
    // Computed properties for select all functionality
  },
  watch: {
    '$route.query.name': {
      handler(newName, oldName) {
        if (newName && newName !== oldName) {
          this.vectorName = newName;
          this.searchVectorDBName2 = newName;
          this.showTable = true;
          this.actionEdit = true;
          this.flagNew = false;
          this.GetDDGroupReplaceDB();
          this.ReFresh();
        }
      },
    },
    options2: {
      handler() {
        this.ReFresh();
      },
      deep: true,
    },
    searchVectorDBName2: {
      handler(newValue) {
        if (typeof newValue === 'string' && newValue.length > 500) {
          this.searchVectorDBName2 = newValue.slice(0, 500);
          return;
        }

        // Clear document name error when user starts typing
        if (this.errors.documentNameError) {
          this.errors.documentNameError = null;
        }
      },
    },
  },
  methods: {
    getRowProps({ item }) {
      if (item.wrongData) {
        return { class: 'wrong-data-row' };
      }
      return {};
    },

    handlePaste(evt) {
      // รับข้อความจาก clipboard
      const clipboardData = evt.clipboardData || globalThis.clipboardData;
      let pastedText = clipboardData.getData('text');

      let filteredText = this.filterVectorNameChars(pastedText);

      // ป้องกันการดำเนินการปกติของการวาง
      evt.preventDefault();

      // นำข้อความที่ผ่านการกรองแล้วมาต่อกับข้อความเดิม
      const cursorPos = evt.target.selectionStart;
      const textBeforeCursor = this.searchVectorDBName2 ? this.searchVectorDBName2.substring(0, cursorPos) : '';
      const textAfterCursor = this.searchVectorDBName2 ? this.searchVectorDBName2.substring(cursorPos) : '';

      const maxLength = 500;
      const remainingLength = maxLength - (textBeforeCursor.length + textAfterCursor.length);

      if (remainingLength <= 0) {
        return;
      }

      filteredText = filteredText.slice(0, remainingLength);

      // อัปเดตค่าใน v-model
      this.searchVectorDBName2 = textBeforeCursor + filteredText + textAfterCursor;

      // เลื่อน cursor ไปยังตำแหน่งหลังข้อความที่วาง
      this.$nextTick(() => {
        evt.target.selectionStart = evt.target.selectionEnd = cursorPos + filteredText.length;
      });
    },

    GetByVector() {
      this.loadingTable = true;
      let { page, itemsPerPage, sortBy } = this.options2;

      // Vue 3 + Vuetify 3: ปรับการจัดการ sorting
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? null : itemsPerPage,
        name: this.$route.query.name == null ? this.searchVectorDBName2 : this.$route.query.name,
        text_org: this.searchtext_org,
        sortDesc: sortOrder,
        sortBy: sortField,
      };

      this.$call.ReFreshVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.dataUpdate = dataResponse.data.dataUpdate;
            this.dataAll = dataResponse.data.dataAll;
            this.searchTotalTable2 = dataResponse.data.table.total;
            this.dataTable2 = dataResponse.data.table.data;
            this.totalTable = dataResponse.data.table.total;
            this.tempgroupReplaceID = dataResponse.data.groupReplaceID;
            if (this.$route.query.name) {
              this.requestVector.customCharacter = dataResponse.data.customCharacter;
              this.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
              this.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
              this.requestVector.PersonalInfo = dataResponse.data.personalInformation;
            }
            this.FlagCheckRefresh(false, dataResponse.data.exceptionFlag);
            this.AutoRefresh();
          } else {
            this.dataTable2 = [];
            this.searchTotalTable2 = 0;
            this.totalTable = 0;
            this.actionEdit = false;
          }
          this.loadingTable = false;
          this.isSearch2 = false;
          this.isFirst2 = false;
          this.showTable = true;
          this.dataTable2.forEach((element) => {
            element.show = this.ShowAllText;
          });
        },
        (errorResource) => {
          this.loadingTable = false;
          this.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    saveDoc() {
      const hasFiles = (this.selectedFilesArray && this.selectedFilesArray.length > 0) || this.requestVector.entity;
      if (!this.requestVector.modelType || !this.searchVectorDBName2 || !hasFiles) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('_pleaseFillAllFields'),
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (!this.validateVectorCommonFields()) {
        return;
      }
      const formDataDoc = new FormData();
      formDataDoc.append('vectordbName', this.searchVectorDBName2);
      formDataDoc.append('modelType', this.requestVector.modelType);
      formDataDoc.append('deleteAll', this.requestVector.deleteAll || false);
      this.appendCommonVectorFields(formDataDoc, this.requestVector.MaxLimitedCharacter);
      formDataDoc.append('PersonalInformation', this.requestVector.PersonalInfo ? 'true' : 'false');

      const filesToUpload = this.selectedFilesArray && this.selectedFilesArray.length > 0 ? this.selectedFilesArray : this.uploadedFiles;

      if (filesToUpload && filesToUpload.length > 0) {
        filesToUpload.forEach((fileItem) => {
          const file = fileItem.originalFile || fileItem; // Handle both wrapped and direct file objects
          formDataDoc.append('entity', file);
        });
      }
      this.dialog = true;
      try {
        const eventCreate = this.$route.query.name == null;
        this.$call.UploadCSV2VectorNew(
          formDataDoc,
          eventCreate,
          (dataResponse) => {
            if (dataResponse.status == 0 && dataResponse.data !== false) {
              let msgSuccess = '✔ ' + dataResponse.message;
              this.showSuccessBanner(msgSuccess);
              this.requestVector.entity = null;
              this.actionEdit = true;
              this.flagNew = false;
              this.uploadedFiles = [];
              this.selectedFiles = [];
              this.selectAll = false;
              this.clearDragDropRef();
              this.dialog = false;
              this.$router.push({
                name: 'UploadVector',
                query: { name: this.searchVectorDBName2 },
              });
              return;
            } else if (dataResponse.status == 0 && !dataResponse.data) {
              //NOSONAR
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warningWaitProcess'),
                showConfirmButton: false,
                timer: 4000,
              });
            } else {
              let msgSuccess = '✔ ' + dataResponse.message;
              let bannerClass = 'success-banner';
              let bannerTitleClass = 'success-banner-title';

              if (dataResponse.message === 'Vector database name Duplicate!') {
                msgSuccess = '✖ ' + this.$t('_DocumentNameDuplicate');
                bannerClass = 'warning-banner';
                bannerTitleClass = 'warning-banner-title';
              }

              this.showSuccessBanner(msgSuccess, { timer: 2500, popupClass: bannerClass, titleClass: bannerTitleClass });
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    cancelSwitchChunk() {
      this.dialog_chunk_onoff = false;
      this.deleteItem.activeFlag = !this.deleteItem.activeFlag;
    },
    VectorOnOff(item) {
      this.ChunkSwitchHeader = item.activeFlag ? 'Turn On Chunk' : 'Turn Off Chunk';
      this.dialog_chunk_onoff = true;
      this.deleteItem = item;
      // var titleAlert = item.activeFlag
      //   ? this.$t("confirmOn")
      //   : this.$t("confirmOff");
      // var textAlert = item.activeFlag
      //   ? this.$t("confirmOnVectorName")
      //   : this.$t("confirmOffVectorName");
      // this.$swal
      //   .fire({
      //     title: titleAlert,
      //     text: textAlert,
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: this.$t("confirm"),
      //     cancelButtonText: this.$t("cancel"),
      //     reverseButtons: false,
      //   })
      //   .then((result) => {
      //     if (result.isConfirmed) {

      //   } else {
      //     item.activeFlag = !item.activeFlag;
      //   }
      // });
    },
    confirmSwitchChunk() {
      let item = this.deleteItem;
      let temp = {
        id: item.id,
        activeFlag: item.activeFlag,
      };
      this.dialog = true;
      try {
        this.$call.VectorOnOff(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.dialog_chunk_onoff = false;
              let msgSuccess = '✔ ' + dataResponse.message;
              this.showSuccessBanner(msgSuccess);
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.dialog_chunk_onoff = false;
            item.activeFlag = !item.activeFlag;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    SaveEdit() {
      if (!this.Edit.textORG) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('_pleaseFillAllFields'),
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      let temp = {
        ID: this.Edit.id,
        Content: this.Edit.textORG,
        MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
        groupReplaceID: this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID),
        DetectLanguage: this.requestVector.DetectLanguage,
      };
      this.dialog = true;
      try {
        this.$call.SaveEditVector(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + dataResponse.message;
              this.showSuccessBanner(msgSuccess);

              setTimeout(() => {
                this.GetByVector();
                this.closeUploaddialog();
              }, 1000);
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    SaveAdd() {
      const resolvedModelType = this.modelType == null ? 1 : this.modelType;
      this.requestVector.modelType = this.requestVector.modelType == null || !this.requestVector.modelType ? resolvedModelType : this.requestVector.modelType;
      if (!this.Add.textORG || !this.requestVector.modelType || !this.searchVectorDBName2) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('_pleaseFillAllFields'),
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (!this.validateVectorCommonFields()) {
        return;
      }
      this.searchVectorDBName2 = this.searchVectorDBName2.trim();
      this.requestVector.vectordbName = this.searchVectorDBName2;
      let temp = {
        vectordbName: this.requestVector.vectordbName,
        modelType: this.requestVector.modelType,
        groupReplaceID: this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID),
        Content: this.Add.textORG,
        flagNew: this.flagNew,
        customCharacter: this.requestVector.customCharacter,
        DetectLanguage: this.requestVector.DetectLanguage,
        MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
        PersonalInformation: this.requestVector.PersonalInfo,
      };
      this.dialog = true;
      try {
        this.$call.SaveAddVector(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + dataResponse.message;
              this.showSuccessBanner(msgSuccess, { backdrop: false, allowDismiss: true });
              this.showTable = true;
              this.actionEdit = true;
              this.flagNew = false;

              await this.$router.replace({
                query: { ...this.$route.query, name: this.requestVector.vectordbName },
              });

              setTimeout(() => {
                this.GetByVector();
                this.closeUploaddialogAdd();
              }, 1000);
              this.requestVector.modelType = null;
            } else {
              this.VectorDBNameDuplicate = this.searchVectorDBName2;
              this.requestVector.modelType = null;
              this.$swal.fire({
                icon: 'warning',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    // ValidateCSVVector(csv, files) {
    //   const formDataDoc = new FormData();
    //   files.forEach(file => {
    //     formDataDoc.append("entity", file);
    //   });
    //   this.uploadedFiles = files;
    //   for(let i=0; i<this.uploadedFiles.length; i++){
    //     this.uploadedFiles[i].id = i + 1;
    //     this.uploadedFiles[i].checked = false;
    //   }
    //   this.requestVector.entity = formDataDoc;
    // },

    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();

      // Add all files with the same field name 'entity'
      files.forEach((file) => {
        formDataDoc.append('entity', file.originalFile || file); // always a real File
      });

      // Add other form parameters as form fields (not query params)
      formDataDoc.append('vectordbName', this.searchVectorDBName2);
      formDataDoc.append('modelType', this.requestVector.modelType);
      formDataDoc.append('deleteAll', this.requestVector.deleteAll || false);
      this.appendCommonVectorFields(formDataDoc, this.requestVector.MaxLimitedCharacter || 20000);
      formDataDoc.append('PersonalInformation', this.requestVector.PersonalInfo ? 'true' : 'false');

      this.uploadedFiles = this.wrapUploadedFiles(files);
      this.requestVector.entity = formDataDoc;
    },
    ConfirmProcess() {
      this.$swal
        .fire({
          icon: 'warning',
          title: this.$t('importVectorTitle'),
          // text: "คุณต้องการนำเข้า Vector",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            // no action required
          }
        });
    },
    DeleteByName(name) {
      try {
        this.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionDocument'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.DeleteVectorDBNameByName(
                name,
                async (dataResponse) => {
                  if (dataResponse.status == 0) {
                    let msgSuccess = '✔ ' + dataResponse.message;
                    this.showSuccessBanner(msgSuccess);
                    this.dataUpdate = 0;
                    this.dataAll = 0;
                    this.actionEdit = false;
                    this.flagNew = true;
                    this.Clear();
                    setTimeout(() => {
                      this.GetByVector();
                    }, 1000);

                    await this.$router.push('/VectorManagement');
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    DeleteById(id) {
      this.dialog_delete_doc = true;
      this.deleteItem = id;
    },
    confirmDeleteDoc() {
      this.dialog_delete_doc = false;
      let id = this.deleteItem;
      try {
        this.dialog = true;
        this.$call.DeleteVectorDBNameById(
          id,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + dataResponse.message;
              this.showSuccessBanner(msgSuccess, { backdrop: false, allowDismiss: true });
              this.GetByVector();
            } else if (dataResponse.status == 1) {
              this.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: true,
                confirmButtonText: this.$t('gotIt'),
                confirmButtonColor: '#d33',
              });
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    AddVectorperChunk() {
      this.AddVector = true;
      this.Add.textORG = null;
    },
    EditVectorperChunk(item) {
      this.EditVector = true;
      this.Edit.id = item.id;
      this.Edit.textORG = item.textORG;
    },

    confirmReprocess() {
      this.dialog_reprocess = false;
      this.executeReprocess(() => {
        this.clickbyexception = true;
        this.exceptionFlag = false;
      });
    },
    ReFresh() {
      try {
        if ((this.$route.query.name != null && this.$route.query.name != '') || (this.searchVectorDBName2 != null && this.searchVectorDBName2 != '')) {
          let { page, itemsPerPage } = this.options2;
          this.sortBy = this.options2.sortBy?.[0]?.key || null;
          this.sortDesc = this.options2.sortBy?.[0]?.order === 'desc' || false;
          let temp = {
            page: this.isSearch ? 1 : page,
            perPage: itemsPerPage == -1 ? null : itemsPerPage,
            name: this.$route.query.name == null ? this.searchVectorDBName2 : this.$route.query.name,
            text_org: this.searchtext_org,
            sortDesc: this.sortDesc,
            sortBy: this.sortBy,
          };
          this.loadingTable = true;
          this.$call.ReFreshVector(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.dataUpdate = dataResponse.data.dataUpdate;
                this.dataAll = dataResponse.data.dataAll;
                this.searchTotalTable2 = dataResponse.data.table.total;
                this.dataTable2 = dataResponse.data.table.data;
                this.totalTable = dataResponse.data.table.total;
                this.tempgroupReplaceID = dataResponse.data.groupReplaceID;
                this.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
                this.requestVector.PersonalInfo = dataResponse.data.personalInformation;
                this.needsReprocessing = dataResponse.data.table.needsReprocessing;
                this.FlagCheckRefresh(true, dataResponse.data.exceptionFlag);
              }
              this.loadingTable = false;
              this.totalTable = this.totalTable + 1;
              this.isSearch2 = false;
              this.isFirst2 = false;
            },
            (errorResource) => {
              this.isSearch2 = false;
              this.loadingTable = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'ReFresh');
      }
    },
    FlagCheckRefresh(v, Flag) {
      if (!this.clickbyexception) {
        // Option B: do not gate auto-refresh on localStorage["ExceptionFlagStop"]. That flag was
        // only ever set by UploadVectorEdit.vue before navigating here, so the normal UploadVector
        // saveDoc flow never resumed polling — the table stayed empty until a manual F5 while the
        // async embedding (ConvertText2Vector) was still writing tblVector. Reflect the real server
        // exception state instead and keep polling until processing finishes (dataUpdate === dataAll)
        // or a real exception occurs.
        this.exceptionFlag = Flag;
        if (v && !Flag) {
          this.AutoRefresh();
        }
      }
    },
    async AutoRefresh() {
      // Prevent multiple AutoRefresh loops
      if (this.autoRefreshRunning) {
        return;
      }

      this.autoRefreshRunning = true;
      let death_waiting = true;

      do {
        if (this.shouldStopAutoRefresh()) {
          death_waiting = false;
        }

        if (death_waiting) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
        }
      } while (death_waiting);

      this.autoRefreshRunning = false;
    },
    closeUploaddialog() {
      this.EditVector = false;
      this.Edit.id = null;
      this.Edit.textORG = null;
    },
    closeUploaddialogAdd() {
      this.AddVector = false;
      this.Add.id = null;
      this.Add.textORG = null;
    },

    closeTemplateVectorDialog() {
      this.TemplateVector = false;
    },

    UpdatePersonalInformation(item, newValue) {
      const hasNewValue = typeof newValue === 'boolean';
      const previousState = hasNewValue ? !newValue : this.requestVector.PersonalInfo;
      const vectorNameInner = item && typeof item === 'object' ? item.vectorDBName : null;
      const vectorNameCandidate = typeof item === 'string' && item ? item : vectorNameInner;
      const vectorName = vectorNameCandidate || (this.$route?.query?.name ?? this.searchVectorDBName2);
      const normalizedVectorName = typeof vectorName === 'string' ? vectorName.trim() : vectorName;

      if (!normalizedVectorName) {
        if (hasNewValue) {
          this.$nextTick(() => {
            this.requestVector.PersonalInfo = previousState;
          });
        }
        console.warn('UpdatePersonalInformation called without a vector name.');
        return;
      }

      this.dialog = true;
      const parameter = {
        VectorDBName: normalizedVectorName,
      };

      this.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = '✔ ' + dataResponse.message;
            this.showSuccessBanner(msgSuccess);
            this.ReFresh();
          } else if (hasNewValue) {
            this.requestVector.PersonalInfo = previousState;
          }
          this.dialog = false;
        },
        (errorResource) => {
          if (hasNewValue) {
            this.requestVector.PersonalInfo = previousState;
          }
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },

    cancelDeleteDoc() {
      this.dialog_delete_doc = false;
      this.deleteItem = null;
    },
    updateFormData() {
      if (this.uploadedFiles.length > 0) {
        const formDataDoc = new FormData();
        this.uploadedFiles.forEach((fileWrapper) => {
          const file = fileWrapper.originalFile || fileWrapper;
          formDataDoc.append('entity', file);
        });

        // Add other form parameters
        formDataDoc.append('vectordbName', this.searchVectorDBName2 || '');
        formDataDoc.append('modelType', this.requestVector.modelType || '');
        formDataDoc.append('deleteAll', this.requestVector.deleteAll || false);
        this.appendCommonVectorFields(formDataDoc, this.requestVector.MaxLimitedCharacter || 20000);
        formDataDoc.append('PersonalInformation', this.requestVector.PersonalInfo ? 'true' : 'false');

        this.requestVector.entity = formDataDoc;
      } else {
        this.requestVector.entity = null;
      }
    },
    gotoEditPage(v) {
      const name = this.searchVectorDBName2 || this.$route.query.name || this.vectorName;
      this.$router.push({
        name: 'UploadVectorEdit',
        query: { name: name, DocEdit: v == 1 ? '1' : '2' },
      });
    },
    getWordCount(text) {
      if (!text) return 0;
      return text.length; //Count Characters
      // Remove extra whitespace and split by whitespace to count words(Count Words)
      //return text.trim().split(/\s+/).filter(word => word.length > 0).length;
    },
  },
};
</script>

<style scoped>
.uv-fw-bold {
  font-weight: bold;
}
.uv-fw-500 {
  font-weight: 500;
}
.uv-word-count {
  font-weight: 400;
  font-size: 16px;
}
.uv-word-count-num {
  color: #c32e0e;
}
.uv-no-shadow {
  box-shadow: none !important;
}
.uv-btn-rounded-flat {
  border-radius: 12px !important;
  text-transform: none;
}
.uv-icon-25 {
  width: 25px;
  height: 25px;
}
.uv-mt-neg-10 {
  margin-top: -10px;
}
.uv-inline-mid {
  display: inline-block;
  vertical-align: middle;
}
.card2 {
  border-radius: 10px !important;
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  padding: 0.75rem;
}

.flex {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.row + .row {
  margin-top: -20px !important;
}

.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}

.v-expansion-panel-header {
  padding: 0;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.text-content-show {
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.responsive-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}

.table-wrapper {
  width: 100%;
  overflow: hidden;
}

.preserve-whitespace {
  white-space: pre;
}

/* Section Wrappers - ลด margin */
.config-wrapper,
.search-wrapper {
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(10px);
  animation: slideInUp 0.25s ease forwards;
}

/* Section Headers - ลด margin และ padding */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 2px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon {
  color: white;
  font-size: 24px;
  opacity: 0.9;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin: 0;
}

/* Cards - ลด border radius และ transition */
.config-card,
.search-card {
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  transition: all 0.15s ease;
}

.config-card:hover,
.search-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.2);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.08);
}

.config-content,
.search-content {
  padding: 16px 16px 12px 16px;
}

/* Form Sections - ลด margin */
.form-section {
  margin-bottom: 0px !important;
}

.subsection-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
  font-weight: 500;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 12px;
}

.subsection-icon {
  color: rgb(var(--v-theme-primary));
  font-size: 18px;
}

.section-divider {
  margin: 10px 0;
  opacity: 0.6;
}

/* Form Rows - ลด padding */
.form-row,
.search-row,
.settings-row {
  margin-bottom: 0;
}

.form-row .v-col,
.search-row .v-col,
.settings-row .v-col {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* Input Wrappers - ลด gap */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 16px;
  font-weight: 400;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

/* Help Icons */
.help-icon {
  color: #a6a6a6;
  cursor: help;
  transition: color 0.15s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

/* Processing Item */
.processing-item {
  border-radius: 6px;
  margin: 1px 6px;
}

.processing-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
}

.processing-avatar {
  border-radius: 4px;
}

/* Tooltip Images */
.tooltip-image {
  border-radius: 6px;
  overflow: hidden;
}

.tooltip-image img {
  display: block;
  border-radius: 6px;
}

/* Switch Components - ลดขนาด */
.switch-container-LangDetect {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  min-width: 80px;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid #0000001e;
}

.language-switch {
  margin: 0;
}

.switch-label-container {
  display: flex;
  align-items: center;
}

.switch-text {
  font-size: 0.8rem;
  color: rgb(var(--v-theme-on-surface));
}
/* tooltip */
.info-tooltip {
  margin-left: 15px !important;
  margin-top: 10px !important;
}
/* Action Section - ลด padding */
.action-section {
  display: flex;
  align-items: center;
  padding-top: 4px;
}

.action-left {
  display: flex;
  align-items: center;
}

.upload-action-wrapper {
  margin-right: 1rem;
  position: relative;
}

/* Style for DragDropFile Component */
.styled-upload-component {
  margin: 0 !important;
  padding: 0 !important;
}

/* Style the upload button inside DragDropFile */
.styled-upload-component :deep(.NoDragDrop .v-btn) {
  background: linear-gradient(135deg, #39843c 0%, #35803a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 0 24px !important;
  height: 48px !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-transform: none !important;
  min-width: 160px !important;
  box-shadow: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
}

/* Hover effect for upload button */
.styled-upload-component :deep(.NoDragDrop .v-btn:hover) {
  background: linear-gradient(135deg, #45a049 0%, #4caf50 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

/* Animation effect */
.styled-upload-component :deep(.NoDragDrop .v-btn::before) {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent) !important;
  transition: left 0.5s ease !important;
}

.styled-upload-component :deep(.NoDragDrop .v-btn:hover::before) {
  left: 100% !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-action-wrapper {
    margin-left: 0;
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }

  .styled-upload-component :deep(.NoDragDrop .v-btn) {
    width: 100% !important;
    min-width: auto !important;
    height: 44px !important;
    font-size: 0.9rem !important;
  }
}

@media (max-width: 480px) {
  .styled-upload-component :deep(.NoDragDrop .v-btn) {
    height: 40px !important;
    font-size: 0.85rem !important;
    padding: 0 16px !important;
  }
}

/* Action Controls */
.action-controls-uploadvector {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* Buttons - ลดขนาด */

.edit-btn {
  color: rgb(255, 178, 34) !important;
  width: 40px !important;
  height: 40px !important;
}
.edit-btn:hover {
  color: white !important;
  background: rgba(13, 71, 161, 0.2) !important;
  border-color: rgba(33, 150, 243, 0.5) !important;
}
.info-btn {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  border-radius: 10px;
}

.checkbox-label {
  font-size: 0.8rem;
  color: rgb(var(--v-theme-on-surface));
}

/* Form Field Enhancements */
:deep(.v-field--variant-outlined) {
  border-radius: 6px;
}

:deep(.v-field--variant-outlined .v-field__outline) {
  --v-field-border-opacity: 0.25;
}

:deep(.v-field--variant-outlined.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

:deep(.v-field--variant-outlined:hover .v-field__outline) {
  --v-field-border-opacity: 0.4;
}

/* Input Focus Effects */
:deep(.v-text-field input),
:deep(.v-select .v-field__input),
:deep(.v-autocomplete .v-field__input) {
  transition: all 0.15s ease;
}

/* Field ขนาดเล็กลง */
:deep(.v-field--density-compact) {
  --v-field-padding-top: 4px;
  --v-field-padding-bottom: 4px;
}

:deep(.v-field--density-compact .v-field__input) {
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

/* Chip Enhancements */
:deep(.v-chip) {
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.75rem;
  height: 24px;
}

/* Switch ขนาดเล็กลง */
:deep(.v-switch) {
  transform: scale(0.9);
}

/* Tooltip ขนาดเล็กลง */
:deep(.v-tooltip .v-overlay__content) {
  font-size: 0.75rem;
  padding: 4px 8px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .action-section {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .action-controls {
    justify-content: center;
  }

  .config-content,
  .search-content {
    padding: 12px;
  }

  .subsection-title {
    font-size: 0.9rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .action-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .template-btn,
  .action-btn-doc,
  .info-btn {
    width: 100%;
    justify-content: center;
    height: 32px;
    font-size: 0.8rem;
  }

  .config-content,
  .search-content {
    padding: 8px;
  }
}

/* Animation - ลดระยะเวลา */
.search-wrapper {
  animation-delay: 0.05s;
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Template Dialog Styles */
.template-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.template-header {
  color: #171717;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #c9c9c9;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: #171717;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: #646464;
}

.close-btn {
  color: #171717 !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.template-content {
  padding: 24px;
}

.template-description {
  margin-bottom: 20px;
}
.custom-alert {
  background: linear-gradient(135deg, #fff2f2 0%, #ffffff 100%);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #c9c9c9;
}
.alert-content {
  font-size: 0.875rem;
}

.template-instructions {
  margin: 8px 0 0 16px;
  padding-left: 10px;
}

.template-instructions li {
  margin: 4px 0;
  line-height: 1.4;
}

.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.mode-type-cell {
  padding: 16px 12px;
}

.mode-type-content {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.info-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.custom-tooltip {
  font-size: 0.8rem;
  line-height: 1.4;
}

.download-cell {
  text-align: center;
  padding: 16px 8px;
}

.excel-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  margin: 8px 0;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 8px;
  min-width: 70px;
  height: 32px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.excel-btn {
  margin-bottom: 4px;
}

.excel-multi-btn {
  font-size: 0.7rem;
  min-width: 75px;
}

.not-available {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}

.template-actions {
  border-top: 1px solid #c9c9c9;
  padding: 16px 24px;
}

.close-action-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 24px;
  height: 40px;
  min-width: 120px;
}
/* Upload Section */
.upload-section {
  grid-column: 1 / -1;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}
.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  border: 1px dashed #949aa8;
  border-radius: 16px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100% !important;
}

.upload-area--ready {
  background: linear-gradient(135deg, rgba(255, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
}

.upload-area .upload-content {
  color: #9ca3af;
}

.upload-area .drag-text,
.upload-area .upload-description span,
.upload-area .choose-file-link {
  color: #9ca3af;
}

.upload-area .choose-file-link {
  text-decoration-color: #9ca3af;
}

.upload-area .upload-state-icon {
  opacity: 0.65;
}

.upload-area .upload-state-icon :deep(img) {
  filter: grayscale(1);
}

.upload-area--ready .upload-content,
.upload-area--ready .drag-text,
.upload-area--ready .upload-description span {
  color: inherit;
}

.upload-area--ready .choose-file-link {
  color: #c32e0e;
  text-decoration-color: #c32e0e;
}

.upload-area--ready .upload-state-icon {
  opacity: 1;
}

.upload-area--ready .upload-state-icon :deep(img) {
  filter: none;
}

.upload-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover {
  border-color: #d1d5db;
  box-shadow: 0 6px 15px rgba(209, 213, 219, 0.45);
}

.upload-area--ready:hover {
  border-color: rgba(255, 242, 242, 1);
  box-shadow: 0 6px 15px rgb(251, 236, 236);
}

.upload-area:hover::before {
  opacity: 1;
}
.upload-main-btn {
  position: relative;
  z-index: 2;
  border-radius: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 0 24px !important;
  height: 48px !important;
  background-color: transparent !important;
  border: 1px solid rgba(195, 46, 14, 0.8) !important ;
  color: #c32e0e;
  transition: all 0.3s ease !important;
}

.upload-main-btn:hover {
  box-shadow: 0 6px 20px rgba(195, 46, 14, 0.35) !important;
  transform: translateY(-1px);
}

.upload-main-btn:active {
  transform: translateY(0);
}
.dashed-divider {
  border-top: 1px dashed rgba(0, 0, 0, 0.4);
}

.customstep-header {
  margin: auto;
  align-items: center;
  justify-content: center;
  width: 70%;
}
.imgsection {
  margin: 5px;
  justify-content: center;
  display: flex;
  border-radius: 5px;
}
/* Different backgrounds by file type */
.bg-csv {
  background: rgba(42, 191, 86, 0.1);
}
.bg-pdf {
  background: rgba(221, 32, 37, 0.1); /* red-400 */
}

.bg-ppt {
  background: rgba(190, 56, 25, 0.1); /* blue-400 */
}

.bg-word {
  background: rgba(56, 89, 208, 0.1); /* blue-500 */
}

.bg-excel {
  background: rgba(15, 120, 62, 0.1); /* green-500 */
}
.bg-multicol {
  background: rgba(15, 120, 62, 0.1);
}
.bg-txt {
  background: rgba(23, 23, 23, 0.1); /* gray-200 */
}
:deep(.customstep-header .v-avatar) {
  width: 50px !important;
  height: 50px !important;
  font-size: 18px !important;
}
:deep(.customstep-header .v-avatar.v-theme--light.v-avatar--density-default.v-avatar--variant-flat.v-stepper-item__avatar) {
  background: linear-gradient(to right, #c32e0e, #f67760) !important;
}
.savebtn {
  background: linear-gradient(135deg, #c32e0e 0%, #f67760 100%);
  color: white !important;
  min-width: 100px;
  border-radius: 12px;
  height: 40px;
  text-transform: none !important;
}
.backbtn {
  color: #c32e0e !important;
  min-width: 120px;
  border-radius: 12px;
  height: 40px;
  text-transform: none !important;
  border: 1px solid #c32e0e;
}
.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.choose-file-link {
  color: #c32e0e;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer !important;
}
.upload-description span {
  font-size: 13px;
  color: #646464;
}
.hidden-upload {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.lang-detect-wrapper {
  background-color: #f0f0f0; /* grey when off */
  border-radius: 12px;
  padding: 16px;
  transition: background-color 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.lang-detect-body {
  display: flex;
  align-items: center;
  gap: 10px;
}

:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #ffe4e1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
/* Responsive Design */
@media (max-width: 768px) {
  .template-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .template-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 28px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  .template-content {
    padding: 16px;
  }

  .excel-buttons {
    flex-direction: row;
    gap: 4px;
  }

  .download-btn {
    font-size: 0.7rem;
    min-width: 60px;
    height: 28px;
  }

  .excel-multi-btn {
    font-size: 0.65rem;
    min-width: 65px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .mode-type-cell,
  .download-cell {
    padding: 12px 6px;
  }
}

@media (max-width: 480px) {
  .template-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.75rem;
  }

  .excel-buttons {
    flex-direction: column;
    gap: 3px;
  }

  .download-btn {
    font-size: 0.65rem;
    min-width: 55px;
    height: 26px;
  }

  .template-instructions {
    font-size: 0.8rem;
  }
}

.actions-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 0.75rem 0.5rem;
  min-width: 140px;
  min-height: 80px;
  justify-content: center;
}

/* Edit Button Styling */
.edit-btn .v-icon {
  color: rgb(33, 150, 243) !important;
}

/* Delete Button Styling */
.delete-btn {
  width: 40px !important;
  height: 40px !important;
}

.delete-btn:hover {
  border-color: rgba(244, 67, 54, 0.5) !important;
}

.delete-btn .v-icon {
  color: rgb(244, 67, 54) !important;
}

/* Enhanced Switch Container */
.switch-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(76, 175, 80, 0.05);
  border: 1px solid rgba(76, 175, 80, 0.2);
  transition: all 0.2s ease;
  min-width: 80px;
}
.switch-container:hover {
  background: rgba(76, 175, 80, 0.1);
  border-color: rgba(76, 175, 80, 0.3);
}
.vector-switch {
  margin: 0;
  transform: scale(0.9);
}

.vector-switch :deep(.v-selection-control) {
  min-height: 28px;
}

/* Switch Label */
.switch-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.8);
  text-align: center;
  line-height: 1.2;
  transition: color 0.2s ease;
  min-width: 50px;
}
.action-buttons-group {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 4px 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}
.action-buttons-group:hover {
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.action-btn-doc {
  border-radius: 6px !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 1px;
  opacity: 0.7;
  width: 32px !important;
  height: 32px !important;
}

.action-btn-doc:hover {
  opacity: 1;
  transform: translateY(-1px);
}
.action-divider {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.12);
  margin: 25px 0;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
  border: 2px dashed rgba(0, 0, 0, 0.12);
}
.action-buttons-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}
:deep(.v-data-table tbody tr) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(25, 118, 210, 0.02);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background-color: rgba(0, 0, 0, 0.02) !important;
}

/* Focus states */
.action-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}
@media (max-width: 768px) {
  .actions-container {
    gap: 8px;
    padding: 0.5rem 0.25rem;
    min-width: 120px;
  }

  .switch-container {
    padding: 0.25rem;
    min-width: 70px;
  }

  .switch-label {
    font-size: 0.65rem;
  }

  .action-buttons-group {
    flex-direction: column;
    gap: 2px;
    padding: 4px;
  }

  .action-divider {
    width: 80%;
    height: 1px;
    margin: 2px 0;
  }

  .action-btn {
    width: 28px !important;
    height: 28px !important;
  }

  .vector-switch {
    transform: scale(0.8);
  }
}

@media (max-width: 480px) {
  .actions-container {
    min-width: 100px;
    gap: 6px;
  }

  .switch-container {
    min-width: 60px;
  }

  .switch-label {
    font-size: 0.6rem;
  }
}

.toggle-section {
  display: flex;
  align-items: center;
}

.compact-toggle {
  background: rgba(255, 255, 255, 0.507);
  border-radius: 6px;
  padding: 0.25rem 0.75rem;
  border: 1px solid #e0e0e0a4;
  margin: 0;
  transform: scale(0.85);
}

.toggle-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  color: #424242;
}
/* Edit Dialog Styles */
.edit-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.edit-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-text .dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
}

.edit-content {
  padding: 24px;
  background-color: #fafafa;
}

.textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
}

.content-textarea {
  background: white;
  border-radius: 8px;
}

.content-textarea :deep(.v-field) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.content-textarea :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.edit-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}

.cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
}

/* Responsive */
@media (max-width: 768px) {
  .edit-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .edit-header {
    padding: 16px 20px;
  }

  .header-text .dialog-title {
    font-size: 1.1rem;
  }

  .edit-content {
    padding: 16px;
  }

  .edit-actions {
    padding: 12px 16px;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
    margin: 0;
  }
}

/* Add Dialog Styles */
.add-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.add-header {
  background: linear-gradient(135deg, #39843c 0%, #2e7d32 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-header .header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.add-header .header-icon {
  font-size: 24px;
  opacity: 0.9;
}

.add-header .header-text .dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.add-header .header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
}

.add-header .close-btn {
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
}

.add-header .close-btn:hover {
  color: white;
  background-color: rgba(0, 0, 0, 0.1);
}

.add-content {
  padding: 24px;
}

.add-content .textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.add-content .textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
}

.add-content .content-textarea {
  background: linear-gradient(90deg, #fff2f2 -15.8%, #fff 100%);
  border-radius: 8px;
}

.add-content .content-textarea :deep(.v-field) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.add-content .content-textarea :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15);
}

.add-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.add-actions .cancel-btn,
.add-actions .save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}

.add-actions .cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
}

.add-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.add-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

/* Responsive for Add Dialog */
@media (max-width: 768px) {
  .add-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .add-header {
    padding: 16px 20px;
  }

  .add-header .header-text .dialog-title {
    font-size: 1.1rem;
  }

  .add-content {
    padding: 16px;
  }

  .add-actions {
    padding: 12px 16px;
    flex-direction: column;
  }

  .add-actions .cancel-btn,
  .add-actions .save-btn {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 480px) {
  .add-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px);
  }

  .add-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .add-header .header-text .dialog-title {
    font-size: 1rem;
  }

  .add-header .header-text .dialog-subtitle {
    font-size: 0.8rem;
  }
}
.switch-container-personal {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  min-width: 80px;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid rgba(255, 152, 0, 0.2);
  background-color: rgba(255, 248, 225, 0.5);
  transition: all 0.2s ease;
}

.switch-container-personal:hover {
  border-color: rgba(255, 152, 0, 0.4);
  background-color: rgba(255, 248, 225, 0.8);
}

.personal-switch {
  margin: 0;
}

.personal-switch :deep(.v-switch__track) {
  opacity: 0.6;
  background-color: rgba(255, 152, 0, 0.2) !important;
}

.personal-switch :deep(.v-switch__track--checked) {
  background-color: rgba(255, 152, 0, 0.6) !important;
}

.personal-switch .switch-label-container {
  display: flex;
  align-items: center;
}

.personal-switch .switch-text {
  font-weight: 500;
  font-size: 0.8rem;
  color: rgb(var(--v-theme-warning));
}
/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #d53b49;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
  border: 2px solid white;
  animation: pulse 2s infinite;
}
.modern-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.2s ease;
}
.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}
.required {
  color: red;
}
/* Animations */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(255, 71, 87, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

.myrandonthing {
  height: 55px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #c9c9c9;
  padding: 12px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.filesize-txt {
  font-size: 13px;
  color: #646464;
}
.filename-txt {
  font-size: 15px;
  font-weight: 600;
  color: #001763;
  max-width: 100%; /* adjust depending on navbar layout */
  white-space: nowrap; /* keeps the text on one line */
  overflow: hidden; /* hides overflowing text */
  text-overflow: ellipsis; /* adds the ... */
  display: inline-block; /* required for ellipsis to work properly */
  vertical-align: middle;
}

/* Multiple Files Table Styles */
.files-table-container {
  margin-top: 16px;
}

.files-table-card {
  border-radius: 12px;
  overflow: hidden;
  border-color: #c9c9c9;
}

.files-table-header {
  background: var(--Table-header-bg, #fff2f2);
  display: flex;
  padding: 2px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.files-data-table {
  background-color: white;
}

.file-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-name {
  font-weight: 500;
  color: #001763;
  font-size: 14px;
}

.file-size {
  font-size: 13px;
  color: #646464;
  font-weight: 500;
}

.files-data-table :deep(.v-data-table__tr) {
  border-bottom: 1px solid #f0f0f0;
  height: 55px !important;
}

.files-data-table .v-data-table__tr:hover {
  background-color: #f8f9fa;
}

.files-data-table .v-data-table-header {
  background-color: #fafafa;
  font-weight: 600;
}

.files-data-table .v-data-table-header th {
  color: #333;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
}

.files-data-table .v-checkbox {
  justify-content: center;
}

:deep(.custom-checkbox .v-selection-control .v-label) {
  font-weight: 500 !important;
}

:deep(.custom-checkbox .v-selection-control__input .v-icon) {
  color: #c32e0e !important;
}

:deep(.custom-checkbox .v-selection-control__input input:checked + .v-icon) {
  background-color: #c32e0e !important;
  border-color: #c32e0e !important;
}

.template-item {
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
  margin: 2px 4px;
}

.template-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.08);
  transform: translateX(4px);
}

/* Table improvements */
:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em;
}

:deep(.replace-mdi-bfe .mdi-menu-down::before) {
  color: #872612 !important;
  content: '\F035D';
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}
.personal-switch-1 {
  margin: 0 !important;
}

.personal-switch-1 :deep(.v-switch__track) {
  opacity: 0.6;
}

.personal-switch-1 :deep(.v-switch__thumb) {
  transition: all 0.2s ease;
}
.personal-switch-1 :deep(.v-input--error) {
  color: inherit !important;
}
/* Hover effects */
.personal-switch-1:hover .personal-icon {
  opacity: 1;
  transform: scale(1.05);
}
.action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px;
  border-radius: 12px;
  transition: all 0.2s ease;
  min-width: 150px;
}
.chunk-dialog-header {
  background: var(--light-gd, linear-gradient(90deg, #e7ebff -18.26%, #fff 100%));
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}
.chunk-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #001763 !important;
  margin: 0 !important;
}
.chunk-confirm-btn {
  background: linear-gradient(135deg, #c32e0e 0%, #f67760 100%);
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}
.white-svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  filter: brightness(0) invert(1);
}

/* Wrong Data Row Highlight */
:deep(.wrong-data-row) {
  background-color: #fff2f2 !important;
  border-left: 3px solid #c32e0e;
}
:deep(.wrong-data-row:hover) {
  background-color: #ffe5e5 !important;
}
</style>
